import * as React from "react";

const s = require("./Tab.scss");

interface Tabs {
    [tab: string]: {
        name: string;
        body: JSX.Element;
    };
}

interface ITabProps {
    tabs: Tabs;
    active: string;
    className?: string;
    onChange: (key: string) => void;
};

interface ITabState {};

class Tab extends React.Component<ITabProps, ITabState> {
    public render(): JSX.Element {
        const headers = Object.keys(this.props.tabs).map(tabKey => {
            const tab = this.props.tabs[tabKey];
            return (
                <li
                    className={(tabKey === this.props.active ? s.active : "")}
                    key={tabKey}
                    onClick={event => this.props.onChange(tabKey)}
                >
                    {tab.name}
                </li>
            );
        });
        return (
            <div className={s.tab + " " + (this.props.className || "")}>
                <ul className={s.tabOptions}>
                    {headers}
                </ul>
                <div className={s.activeTab}>
                    {this.props.tabs[this.props.active].body}
                </div>
            </div>
        );
    }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/components/Tab/index.tsx